import { combineReducers, configureStore } from "@reduxjs/toolkit"
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist"
import storage from "redux-persist/lib/storage"
import cartReducer from "./cartRedux"
import userReducer from "./userRedux"
import orderReducer from "./orderRedux"
import environmentReducer from "./environmentRedux"

const persisConfig = {
    key: "root",
    version: 1,
    storage
}

const rootReducer = combineReducers({ user: userReducer, cart: cartReducer, order: orderReducer, environment: environmentReducer })

const persistedReducer = persistReducer(persisConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        })
})

export const persistor = persistStore(store)